import {connect} from 'react-redux';

import {ContactCardPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {VisualContactModel} from '../../../../models/api/visualContactModel';
import {getHasNoCalendars} from '../../../../store/data/calendarVersions/calendarVersionsSelectors';
import {contactCardCreateNewCalendarEventAction} from '../../../../store/panels/contacts/contactCard/contactCardPanelActions';
import {makeGetContactCardPanel} from '../../../../store/panels/contacts/contactCard/contactCardPanelSelectors';
import {ContactCardFooterNewEvent} from './contactCardFooterNewEvent';

/*
 * Props.
 */

interface ContactCardFooterNewEventContainerProps {
  panelId: ContactCardPanelId;
  visualContact: VisualContactModel;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ContactCardFooterNewEventContainerProps>()(() => ({
  hasNoCalendars: getHasNoCalendars,
  panel: makeGetContactCardPanel(),
}));

const mapDispatchToProps = makeMapDispatchToProps<ContactCardFooterNewEventContainerProps>()(
  ({panelId, visualContact}) => ({
    onCreateNewEvent: () => contactCardCreateNewCalendarEventAction(panelId, visualContact),
  }),
);

export const ContactCardFooterNewEventContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContactCardFooterNewEvent);
